<template>
  <div class="header-filter-list">
    <p
      class="item"
      v-for="(tab, tabIndex) in tabList"
      :key="tabIndex"
      @click="handleChangeTab(tab)"
      :class="{ active: currentValue === tab.value }"
    >
      <span>
        <i
          class="iconfont icon-caogaoxiang"
          style="width: 16px"
          v-if="tab.icon"
        ></i>
        {{ tab.label }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'custom-tab-component',
  model: {
    prop: 'value', // 绑定的 prop 名称
    event: 'change', // 触发的事件名称
  },
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentValue: this.value,
    }
  },
  methods: {
    handleChangeTab(tab) {
      this.currentValue = tab.value
      this.$emit('change', tab.value)
      this.$emit('handleChange', tab)
    },
  },
  mounted() {
    //
  },
  watch: {
    value(newVal) {
      this.currentValue = newVal
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.header-filter-list {
  display: flex;
  align-items: center;
  .item {
    padding-right: 12px;
    // border-right: 1px solid #98a3b7;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    cursor: pointer;
    position: relative;
  }
  .item:last-child {
    margin-left: 12px;
  }
  .item:nth-last-child(2)::after {
    content: '';
    display: inline-block;
    width: 1px;
    height: 16px;
    flex-shrink: 0;
    border-radius: 2px;
    background: #98a3b7;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -8px;
  }
  .item.active {
    color: #0863ff;
    position: relative;
  }
  .item.active::before {
    content: '';
    display: inline-block;
    width: 60px;
    height: 4px;
    flex-shrink: 0;
    border-radius: 10px;
    background: linear-gradient(90deg, #0863ff99 0%, #0863ff00 61.54%);
    position: absolute;
    bottom: 3px;
    left: 0;
  }
}
</style>
